interface BeaconPinger {
  startHeartbeat(): void;
  stopHeartbeat(): void;
}

// Module-scoped rather than fields on BeaconGateway because they have to outlive
// it: init() has no re-entry guard, so a second call tears the gateway down while
// the chat client — and the session — carries on. The replacement is built by the
// next conversation signal, not by init.
let sessionActive = false;
let beaconPinger: BeaconPinger | null = null;

/**
 * Attach the live gateway, or detach with `null`. Detaching does not end the
 * session — `stopBeaconPipeline` runs on every re-init.
 */
export function registerBeaconPinger(gateway: BeaconPinger | null): void {
  beaconPinger = gateway;
  if (beaconPinger && sessionActive) {
    beaconPinger.startHeartbeat();
  }
}

export function chatSessionStarted(): void {
  sessionActive = true;
  beaconPinger?.startHeartbeat();
}

export function chatSessionEnded(): void {
  sessionActive = false;
  beaconPinger?.stopHeartbeat();
}
